import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

const Portal = ({children, selector}) => {
  const getChildren =
    typeof children === 'function' ? children : () => children;

  return Array.from(document.querySelectorAll(selector), (node) => {
    const props = node.dataset ? node.dataset : {};
    return ReactDOM.createPortal(getChildren(props), node);
  });
};

Portal.propTypes = {
  selector: PropTypes.string.isRequired,
};

export default Portal;
